import { render, staticRenderFns } from "./MyPortal.vue?vue&type=template&id=36365c76&scoped=true&"
import script from "./MyPortal.vue?vue&type=script&lang=js&"
export * from "./MyPortal.vue?vue&type=script&lang=js&"
import style0 from "./MyPortal.vue?vue&type=style&index=0&id=36365c76&scoped=true&lang=css&"
import style1 from "./MyPortal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36365c76",
  null
  
)

export default component.exports